<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">NSS Committee</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">NSS Committee</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="minority-cell ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table--4">
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Name Of the Member</th>
                <th>Role in Committee</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Prof.Mohini Pardeshi</td>
                <td>Programme Officer/Chairman</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Prof.M.B.Pisal</td>
                <td>Teaching Representative</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Prof.Cheena Kabra</td>
                <td>Teaching Representative</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Ms.Priti Gosavi</td>
                <td>Student Representative</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Mr.Nikhil Jagdale</td>
                <td>Student Representative</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Mr.Alim Mulani</td>
                <td>Member</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
